export default {"src":"/_next/static/media/tablet-flawless.8c98e983.svg","height":75,"width":80};